<template>
    <div>
        <span v-if="inline">
            <Money
                :data="data.total"
                :formatter="moneyFormatter"
            />

            <span v-if="taxText"> ({{ taxText }}) </span>
        </span>

        <span
            v-else
            class="price"
        >
            <Money
                :data="data.total"
                :formatter="moneyFormatter"
                role="heading"
                aria-level="2"
            />

            <span
                v-if="taxText"
                class="tax"
                data-qa="price-tax"
            >
                {{ taxText }}
            </span>
        </span>
    </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import type { TaxSnippetFragment } from '@/graphql/api'
import { assertNever } from '@/helpers'
import { useMoneyFormatter } from '@/plugins/money-formatter.ts'

import Money from '@/components/Money.vue'

const { t } = useI18n()

const props = defineProps<{
    data: TaxSnippetFragment
    inline?: boolean
}>()

const moneyFormatter = useMoneyFormatter()

const taxText = computed(() => {
    if (!props.data.tax) {
        return t('catalogue.tax_snippet.excluding_taxes')
    }

    switch (props.data.tax.type) {
        case 'VAT':
        case 'GST':
            return ''
        // return t('catalogue.tax_snippet.including_vat', {
        //     price: format(props.data.gst.price),
        // })
        case 'SALES':
            return t('catalogue.tax_snippet.including_sales')
        default:
            return assertNever(props.data.tax.type, '')
    }
})
</script>

<style lang="scss" scoped>
.price {
    font-size: 1.5rem;
    line-height: 1.25em;
    font-family: $parcel-font-stack;
    display: block;
    margin: 0 0 15px;

    .tax {
        font-size: 1rem;
        display: block;
    }
}
</style>
